import "./header.css"
export default function Header() {
  return (
    <div className="header">
      <div className="headerTitles">
    <span className="headerTitleSmall">React & Node</span><br></br>
    <span className="headerTitleslarge">Blog</span>
    <img className="headerimg" src="img.jpg" alt="" />
    </div>
    </div>
  )
}
